function hulkappsModalFormInit() {
  let isFormSubmit = false;
  const modal = document.querySelector('.hulk-modal');
  const exitModal = document.querySelector('.hulk-modal span.close');

  if (!modal || !exitModal) return;

  const formIds = {
    'rx-obagi-hydroquinone': 'eIHRi1E31rjr28ZzmMM58Q',
    'rx-obagi-tretinoin': 'PLBERkOGy3o6ROwFLd9vmA',
    'rx-upneeq': 'SbAUGc0CiyCcRJYGTzxe6A',
    'rx-latisse': 'ygw0zksI1_WwHGVdLNlIUw',
  };

  function showModal() {
    modal.style.display = 'flex';
    document.documentElement.classList.add('prevent_scroll');
  }

  function hideModal() {
    modal.style.display = 'none';
    document.documentElement.classList.remove('prevent_scroll');
  }

  function createFormIframe(form) {
    let iframe = form.querySelector('iframe');
    if (iframe) return iframe;

    const formUrl = new URL('https://formbuilder.hulkapps.com/corepage/customform');
    formUrl.searchParams.set('id', form.id);
    formUrl.searchParams.set('referrer_url', window.location.href);
    if (form.dataset.customerEmail) {
      formUrl.searchParams.set('customer_email', form.dataset.customerEmail);
    }

    iframe = document.createElement('iframe');
    iframe.src = formUrl.toString();
    iframe.id = `frame_${form.id}`;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('title', form.dataset.formTitle || 'Prescription approval form');
    form.appendChild(iframe);
    return iframe;
  }

  function showForm(formId) {
    const formToShow = document.getElementById(formId);
    if (!formToShow) return null;

    document.querySelectorAll('.hulk-form-placeholder').forEach((form) => {
      form.style.display = 'none';
    });

    const iframe = createFormIframe(formToShow);
    formToShow.style.display = 'block';
    return iframe;
  }

  function sendProductsToForm(iframe, products) {
    let attempts = 0;
    const hook = window.setInterval(() => {
      attempts += 1;
      if (iframe.contentWindow) {
        iframe.contentWindow.postMessage({ products }, 'https://formbuilder.hulkapps.com');
      }
      if (attempts >= 40) window.clearInterval(hook);
    }, 500);

    const confirmReceipt = (event) => {
      if (event.origin === 'https://formbuilder.hulkapps.com' && event.data && event.data.received) {
        window.clearInterval(hook);
        window.removeEventListener('message', confirmReceipt);
      }
    };
    window.addEventListener('message', confirmReceipt);
  }

  exitModal.addEventListener('click', hideModal);
  document.addEventListener('click', (event) => {
    if (event.target === modal) hideModal();
  });

  document.body.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton || isFormSubmit) return;

    event.preventDefault();
    checkCart();
  }, true);

  // --- Rx safety net (added 2026-08-17) -------------------------------------------------
  // The product form stamps Rx items with properties[_approval_needed] (see
  // snippets/collection-product__form.liquid). Items added by other paths — upsell
  // pop-ups, "Buy again", quick-adds via /cart/add.js — arrive WITHOUT that property.
  // For any item lacking it we look up the product's tags and, if it is an Rx product,
  // (a) repair the property on the cart line so the order is still flagged for staff, and
  // (b) gate checkout behind the approval form exactly as before.
  const rxTagCache = {};

  async function lookupRxTag(handle) {
    if (!handle) return null;
    if (Object.prototype.hasOwnProperty.call(rxTagCache, handle)) return rxTagCache[handle];
    let found = null;
    try {
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        const product = await response.json();
        const tags = Array.isArray(product.tags)
          ? product.tags
          : String(product.tags || '').split(',').map((tag) => tag.trim());
        found = tags.find((tag) => formIds[tag]) || null;
      }
    } catch (error) {
      found = null;
    }
    rxTagCache[handle] = found;
    return found;
  }

  async function repairApprovalProperty(item, tag) {
    try {
      const properties = Object.assign({}, item.properties || {}, { _approval_needed: tag });
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
      });
    } catch (error) {
      // Non-fatal: the checkout is still gated below even if the repair failed.
    }
  }

  async function resolveApprovalTags(cart) {
    const approvalTags = [];
    for (const item of cart.items) {
      let tag = item.properties && item.properties._approval_needed;
      if (!(tag && formIds[tag])) {
        tag = await lookupRxTag(item.handle);
        if (tag) await repairApprovalProperty(item, tag);
      }
      if (tag && formIds[tag]) approvalTags.push(tag);
    }
    return approvalTags;
  }
  // -------------------------------------------------------------------------------------

  async function checkCart() {
    let approvalTags = [];
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      approvalTags = await resolveApprovalTags(cart);
    } catch (error) {
      approvalTags = [];
    }

    if (approvalTags.length === 0) {
      isFormSubmit = true;
      hideModal();
      window.location.href = '/checkout';
      return;
    }

    const activeIframe = showForm(formIds[approvalTags[approvalTags.length - 1]]);
    if (!activeIframe) return;

    sendProductsToForm(activeIframe, approvalTags);
    showModal();
  }
}

document.addEventListener('DOMContentLoaded', hulkappsModalFormInit);

window.addEventListener('message', (event) => {
  if (event.data === 'close_modal') {
    const modal = document.querySelector('.hulk-modal');
    if (modal) {
      modal.style.display = 'none';
      document.documentElement.classList.remove('prevent_scroll');
    }
  }
});
